
































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import utils from '@/services/utils';
import AuthModule from '@/store/modules/Auth';

@Component
export default class CoinLogBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: any;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly fetchResult!: Function;

  @Prop() readonly totalLog!: number;

  @Prop() readonly summaryWinlose!: number;

  accurryDecimal = ['USD', 'NZD', 'KWD'];

  utilsInstance = utils;

  isAdmin = ['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role);

  getDateTimeStamp(date) {
    return this.$moment(date).format('YYYYMMDD') >= 20240227;
  }
}
